// @flow
import React from "react";
import { Text, UploadWidget } from "buba-components";
import { allowedFileFormats } from "buba-components/src/utils/fileFormats";
import bindingOfferModalContentStyles from "./BindingOfferModalContent.scss";

type BindingOfferModalContentProps = {
  setFile: File => void,
  displayErrorForStatusCode: (?number) => void,
  fileName: ?string,
  isLoading: boolean
};

const BindingOfferModalContent = ({
  setFile,
  displayErrorForStatusCode,
  fileName,
  isLoading
}: BindingOfferModalContentProps) => {
  const uploadWidgetProps = {
    errorCallback: error => displayErrorForStatusCode(error.response.status),
    fileTypes: allowedFileFormats,
    initialStatus: "not_uploaded",
    name: "uploadDocumentsForBankOffer",
    selectedCallback: ({ file, setStatus }) => {
      setFile(file);
      setStatus("ready_for_upload");
    },
    title: fileName || "Dokument auswählen",
    isButtonDisabled: isLoading
  };

  return (
    <>
      <Text>
        Bitte stellen Sie dem Kunden mit Hilfe des Buttons &quot;JETZT HOCHLADEN&quot; das Angebot
        zur Verfügung und klicken Sie anschließend auf &quot;GENEHMIGUNG ABSCHLIESSEN&quot;
      </Text>
      <div className={bindingOfferModalContentStyles.fileContainer}>
        <UploadWidget {...uploadWidgetProps} />
      </div>
    </>
  );
};

export default BindingOfferModalContent;
